<!-- Standard Payment Module -->

<div class="main">
		<div class="content">

						<div class="sap_tabs">
							<div id="horizontalTab" style="display: block; width: 100%; margin: 0px;">
							    <div class="pay-tabs" style="padding: 2em 2.5em;">
									  <form>
									        <h5 style="font-weight: 600; text-transform: uppercase;font-size: small;color: gray;padding-bottom: 5px;"> Purpose of Payment</h5>
									    <select name="purpose" style="width: 100%;height: 35px;padding: 5px 20px;background-color: #fff;border: 1px solid #e1e1e1;border-radius: 6px;">
									        <option value="">Select Payment Purpose</option>
									        <option value="Subscription">Subscription</option>
									        <option value="AMC">AMC</option>
									        <option value="Calibration">Calibration</option>
									        <option value="Initial_Deposit">Initial Deposit</option>
									    </select>
									  </form>
								</div>
								<div class="pay-tabs">
									<h2>Select Payment Method</h2>
									  <ul class="resp-tabs-list">
										  <li class="resp-tab-item" (click)="change(1)" [style.color] = "color[0]  ? 'green' : 'grey'"><span>Credit Card</span></li>
										  <li class="resp-tab-item" (click)="change(2)" [style.color] = "color[1]  ? 'green' : 'grey'"><span>Net Banking</span></li>
										  <li class="resp-tab-item" (click)="change(3)" [style.color] = "color[2]  ? 'green' : 'grey'"><span>PayTM</span></li>
										  <li class="resp-tab-item" (click)="change(4)" [style.color] = "color[3]  ? 'green' : 'grey'"><span>UPI Payments</span></li>
										  <div class="clear"></div>
									  </ul>
								</div>
								<div class="resp-tabs-container">
									<div *ngIf="paymentOpt === 1">
										<div class="payment-info">
											<h3>Personal Information</h3>
											<form>
												<div class="tab-for">
													<h5>EMAIL ADDRESS</h5>
														<input type="text" value="">
													<h5>FIRST NAME</h5>
														<input type="text" value="">
												</div>
											</form>
											<h3 class="pay-title">Credit Card Info</h3>
											<form>
												<div class="tab-for">
													<h5>NAME ON CARD</h5>
														<input type="text" value="">
													<h5>CARD NUMBER</h5>
														<input class="pay-logo" type="text" value="0000-0000-0000-0000" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = '0000-0000-0000-0000';}" required="">
												</div>
												<div class="transaction">
													<div class="tab-form-left user-form">
														<h5>EXPIRATION</h5>
															<ul>
																<li>
																	<input type="number" class="text_box" type="text" value="6" min="1" />
																</li>
																<li>
																	<input type="number" class="text_box" type="text" value="1988" min="1" />
																</li>

															</ul>
													</div>
													<div class="tab-form-right user-form-rt">
														<h5>CVV NUMBER</h5>
														<input type="text" value="xxxx" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = 'xxxx';}" required="">
													</div>
													<div class="clear"></div>
												</div>
												<button ><a href="#">Submit</a></button>
											</form>
											<div class="single-bottom">
													<ul>
														<li>
															<input type="checkbox"  id="brand" value="">
															<label for="brand"><span></span>By checking this box, I agree to the Terms & Conditions & Privacy Policy.</label>
														</li>
													</ul>
											</div>
										</div>
									</div>
									<div *ngIf="paymentOpt === 2">
										<div class="payment-info">
											<h3>Net Banking</h3>
											<div class="radio-btns">
												<div class="swit">
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio" checked=""><i></i>Andhra Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Allahabad Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Bank of Baroda</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Canara Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>IDBI Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Icici Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Indian Overseas Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Punjab National Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>South Indian Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>State Bank Of India</label> </div></div>
												</div>
												<div class="swit">
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio" checked=""><i></i>City Union Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>HDFC Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>IndusInd Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Syndicate Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Deutsche Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Corporation Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>UCO Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Indian Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>Federal Bank</label> </div></div>
													<div class="check_box"> <div class="radio"> <label><input type="radio" name="radio"><i></i>ING Vysya Bank</label> </div></div>
												</div>
												<div class="clear"></div>
											</div>
											<a href="#">Continue</a>
										</div>
									</div>
									<div *ngIf="paymentOpt === 3">
										<div class="payment-info">
											<h3>PayTM</h3>
											<h4>Already Have A PayTM Account?</h4>
											<div class="login-tab">
												<div class="user-login">
													<h2>Login</h2>

													<form>
														<input type="text" value="name@email.com" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = 'name@email.com';}" required="">
														<input type="password" value="PASSWORD" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = 'PASSWORD';}" required="">
															<div class="user-grids">
																<div class="user-left">
																	<div class="single-bottom">
																			<ul>
																				<li>
																					<input type="checkbox"  id="brand1" value="">
																					<label for="brand1"><span></span>Remember me?</label>
																				</li>
																			</ul>
																	</div>
																</div>
																<div class="user-right">
																	<input type="submit" value="LOGIN">
																</div>
																<div class="clear"></div>
															</div>
													</form>
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="paymentOpt === 4">
										<div class="payment-info">

											<h3 class="pay-title">UPI Info</h3>
											<form>
												<div class="tab-for">
													<h5>Enter UPI Address</h5>
														<input type="text" value="">
													<h5>CONTACT NUMBER</h5>
														<input class="pay-logo" type="text" value="" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = '0000-0000-0000-0000';}" required="">
												</div>
												<!-- <div class="transaction">
													<div class="tab-form-left user-form">
														<h5>EXPIRATION</h5>
															<ul>
																<li>
																	<input type="number" class="text_box" type="text" value="6" min="1" />
																</li>
																<li>
																	<input type="number" class="text_box" type="text" value="1988" min="1" />
																</li>

															</ul>
													</div> -->
													<!-- <div class="tab-form-right user-form-rt">
														<h5>CVV NUMBER</h5>
														<input type="text" value="xxxx" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = 'xxxx';}" required="">
													</div> -->

												<input type="submit" value="SUBMIT">
											</form>
											<div class="single-bottom">
													<ul>
														<li>
															<input type="checkbox"  id="brand" value="">
															<label for="brand"><span></span>By checking this box, I agree to the Terms & Conditions & Privacy Policy.</label>
														</li>
													</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

		</div>
	</div>
